import { Permission } from "src/entity/permission/permission";
import { Children, Menu, Menu as ProfileMenusProps } from "src/entity/profile/profile.entity";

export const findPermissionsByPath = (path: string, menuItems: ProfileMenusProps[]): string[] | null => {
  for (let item of menuItems) {
    if (item.path === path) {
      return item.permission || [];
    }
    if (item.children && item.children.length > 0) {
      const result = findPermissionsByPath(path, item.children as ProfileMenusProps[]);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

export const cutOffMenusForNV = (menus: Menu[]) => {
  // Helper function to recursively filter the menu
  function filterMenus(menus: Menu[]) {
    return menus.filter((menu: Children) => {
      // Remove menu if it contains 'nv' in its permission array
      if (
        menu.permission.includes(Permission.A) ||
        menu.permission.includes(Permission.CN) ||
        menu.permission.includes(Permission.EA) ||
        menu.permission.includes(Permission.EO) ||
        menu.permission.includes(Permission.V) ||
        menu.permission.includes(Permission.VO)
      )
        return true;
      else if (menu.permission.includes(Permission.NV)) {
        return false;
      }

      // Recursively filter children
      if (menu.children && menu.children.length > 0) {
        menu.children = filterMenus(menu.children as any);
      }

      // If after filtering children, the children array is empty, remove the parent menu
      if (menu.children && menu.children.length === 0 && menu.permission.length === 0) {
        return false;
      }

      return true;
    });
  }

  return filterMenus(menus);
};
